import { atom } from 'jotai';

import type { RecordingEntry } from '@/features/rpa/recorder/model/types';

export const recordingsAtom = atom<readonly RecordingEntry[]>([]);
